import styled from 'styled-components';

export const ToggleBox = styled.div`
  padding: 20px 35px;
  border-width: 1px 0 0;
  border-style: solid;
  border-color: #dae1f4;
`;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/styles/ToggleBox.js